<template>
  <RkTable class="major-table" :data="sliceShareholderList" :loading="loading" :finished="finished">
    <template #footer>
      <ShowMoreButton v-if="shareholderList.length > 5" v-model="isMore" />
    </template>
    <RkTableColumn prop="holderName" label="股东名称" fixed align="left" :width="`${postcssPatch(130)}`">
      <template #default="{ row }">{{ $digitjs(row.holderName).isNull() }}</template>
    </RkTableColumn>
    <RkTableColumn prop="holdingNumber_OS" label="持股数量" :width="`${postcssPatch(90)}`">
      <template #default="{ row }">{{ $digitjs(row.holdingNumber_OS).convert() }}</template>
    </RkTableColumn>
    <RkTableColumn prop="holdingRatio" label="持股比例" :width="`${postcssPatch(90)}`">
      <template #default="{ row }">{{ $digitjs(row.holdingRatio).unit('%').rounded() }}</template>
    </RkTableColumn>
    <RkTableColumn prop="changeNumber_OS" label="变动股数" :width="`${postcssPatch(120)}`">
      <template #default="{ row }">
        <span>{{ $digitjs(row.changeNumber_OS).prefix().convert() }}</span>
        <i
          v-if="row.changeNumber_OS < 0"
          class="iconfont icon-xiangxiajiantoucuxiao"
          :style="{ color: theme['--down-color'] }"
        ></i>
        <i
          v-if="row.changeNumber_OS > 0"
          class="iconfont icon-xiangshangjiantoucuxiao"
          :style="{ color: theme['--up-color'] }"
        ></i>
      </template>
    </RkTableColumn>
  </RkTable>
</template>

<script>
import ShowMoreButton from '@/components/common/ShowMoreButton.vue'
import { postcssPatch } from '@/utils/postcssPatch'
export default {
  components: { ShowMoreButton },
  inject: ['theme'],
  props: ['total'],
  data() {
    return {
      loading: false,
      finished: false,
      isMore: false,
      shareholderList: []
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    sliceShareholderList() {
      return this.isMore ? this.shareholderList : this.shareholderList.slice(0, 5)
    }
  },
  created() {
    this.getShareholderList()
  },
  methods: {
    postcssPatch,
    async getShareholderList() {
      this.loading = true
      const res = await this.$post(this.$api.f10.us + '/summary/major-shareholders', {
        symbol: this.symbol
      })
      const data = res.data ?? []
      this.shareholderList = data.sort((a, b) => b.holdingRatio - a.holdingRatio).slice(0, 10)
      this.finished = true
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.major-table {
  --table-tbody-font-size: 13px;
}
</style>
